// extracted by mini-css-extract-plugin
module.exports = {"dashboardLettersButtons":"dashboard-letters-buttons_dashboardLettersButtons__1yFqk","button":"dashboard-letters-buttons_button__urupi"};